import * as React from "react";
const RealTimeVisibilitySVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={68}
    height={68}
    fill="none"
    {...props}
  >
    <rect
      width={60}
      height={60}
      x={4}
      y={4}
      fill="#EF4136"
      fillOpacity={0.03}
      rx={30}
    />
    <rect
      width={60}
      height={60}
      x={4}
      y={4}
      stroke="#EF4136"
      strokeOpacity={0.06}
      strokeWidth={8}
      rx={30}
    />
    <path
      fill="#EF4136"
      d="M48.914 33.595c-.044-.099-1.103-2.447-3.456-4.801C42.32 25.657 38.36 24 34 24s-8.321 1.657-11.457 4.794c-2.354 2.354-3.418 4.706-3.457 4.801a1 1 0 0 0 0 .813c.044.098 1.103 2.446 3.457 4.8C25.678 42.343 29.64 44 34 44s8.321-1.657 11.458-4.792c2.353-2.354 3.412-4.702 3.456-4.8a1 1 0 0 0 0-.813ZM34 42c-3.848 0-7.209-1.399-9.991-4.156A16.683 16.683 0 0 1 21.125 34a16.67 16.67 0 0 1 2.884-3.844C26.79 27.4 30.152 26 34 26c3.847 0 7.209 1.399 9.991 4.156A16.68 16.68 0 0 1 46.881 34c-.901 1.682-4.827 8-12.881 8Zm0-14a6 6 0 1 0 6 6 6.006 6.006 0 0 0-6-6Zm0 10a4 4 0 1 1 0-8 4 4 0 0 1 0 8Z"
    />
  </svg>
);
export default RealTimeVisibilitySVG;
